import React from 'react';
import classNames from 'classnames';

import { SliderWrapper } from '@/components/ui';
import { hooks as fiberHooks } from '@/domains/fiber';

import useTranslation from 'next-translate/useTranslation';
import FiberOfferItem from './FiberOfferItem';

import styles from './index.module.scss';

const FiberOffers = ({ data }) => {
  const { lang } = useTranslation();

  const { data: fiberTariffs } = fiberHooks.useFiberTariffs({ lang });
  return (
    <div
      className={classNames('wrapper', styles.offerWrapper)}
      itemScope
      itemType='https://schema.org/Offer'
    >
      <h1>
        {data?.title}
        {fiberTariffs?.title}
      </h1>
      <SliderWrapper
        arrows
        options={{
          infinite: fiberTariffs?.length > 4,
          slidesToShow: 4,
        }}
        className={''}
        nextArrow={true}
        prevArrow={true}
        shadow={null}
      >
        {fiberTariffs?.map((item) => (
          <FiberOfferItem key={item?.key} offerItem={item} />
        ))}
      </SliderWrapper>
    </div>
  );
};

export default FiberOffers;
